// Fire-and-forget sync into the shared Hub app, fired only after a UCR
// payment has already succeeded (see PaymentInfo's onSave). This call
// originates from the browser, so unlike MCS-150/Oregon Permit Filing's
// server-to-server sync it cannot carry a secret header -- Hub's
// /api/ingest/ucr endpoint is deliberately public, same trust level this
// app's existing calls to the real UCR backend already have. Never allowed
// to affect the payment flow itself -- always called after navigate(), and
// any failure here is swallowed by the caller.
const IS_DEV = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const HUB_ENDPOINT = IS_DEV
  ? "http://localhost:3000/api/ingest/ucr"
  : "https://hub.example.com/api/ingest/ucr";

const HUB_BASE_URL = IS_DEV ? "http://localhost:3000" : "https://hub.example.com";

export const HUB_LOGIN_URL = `${HUB_BASE_URL}/login`;
export const HUB_REGISTER_URL = `${HUB_BASE_URL}/register`;
export const HUB_DASHBOARD_URL = `${HUB_BASE_URL}/dashboard`;

// UCR has no server of its own to verify Hub's (httpOnly) session cookie
// directly, unlike MCS-150/Oregon Permit Filing -- so it asks Hub itself via
// a credentialed cross-origin request. Hub's /api/customer/session-status
// only ever answers with a boolean, never the customer's identity, and only
// echoes CORS headers back for this app's own configured origin.
export const checkHubSession = () =>
  fetch(`${HUB_BASE_URL}/api/customer/session-status`, { credentials: "include" })
    .then((res) => (res.ok ? res.json() : { loggedIn: false }))
    .then((data) => !!data.loggedIn)
    .catch(() => false);

export const syncToHub = (payload) =>
  fetch(HUB_ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
